// client/src/pages/Partners.js

import React from 'react';
import { Link } from 'react-router-dom';

const Partners = () => {
  return (
    <section className="section-wrapper bg-white px-6 py-12 md:px-20 text-deep-navy">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl font-bold text-primary mb-6 text-center">
          Strategic Partnerships at BetterTurns
        </h2>

        <p className="text-lg mb-4">
          BetterTurns is building a next-generation ERP and POS platform
          designed to uplift Tier 3 retailers—independent shop owners who have
          historically been underserved by large tech vendors.
        </p>

        <p className="text-lg mb-6">
          We are seeking partnerships that bring mutual value, accelerate
          adoption, and create shared success across payment processing, supply
          chain, and investment channels.
        </p>

        <div className="bg-soft-earth p-6 rounded shadow mb-8 space-y-3">
          <h3 className="text-xl font-semibold text-primary mb-2">
            Ideal Partners
          </h3>
          <ul className="list-disc pl-5 text-gray-700 space-y-1">
            <li>Card processors seeking growth in Tier 3 retail</li>
            <li>Vendors supporting small business ecosystems</li>
            <li>Strategic investors aligned with long-term co-op values</li>
            <li>
              Distributors interested in co-marketing and data-driven engagement
            </li>
          </ul>
        </div>

        <div className="mb-6">
          <h4 className="text-lg font-semibold mb-2">
            Potential Collaboration Models
          </h4>
          <ul className="list-disc pl-5 space-y-1 text-gray-700">
            <li>Co-branded offerings or white-label integrations</li>
            <li>Revenue share models with capped or tiered terms</li>
            <li>
              Equity stake in exchange for pilot support or early deployment
              incentives
            </li>
            <li>Co-marketing campaigns to reach independent retailers</li>
          </ul>
        </div>

        <p className="text-lg mb-6">
          We’re especially interested in aligning with partners who value
          ethical governance, decentralized growth, and empowering local
          economies.
        </p>

        <div className="text-center">
          <a
            href="mailto:partner@betterturns.com"
            className="inline-block bg-primary text-white px-6 py-3 rounded shadow hover:bg-primary-dark transition"
          >
            Reach Out to Discuss a Partnership
          </a>
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/"
            className="text-sunshine-yellow font-semibold hover:text-warm-orange"
          >
            ← Back to Home
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Partners;
